import {AlertModalActionType} from "../../const/actionType";
import {ALERT_VARIANT} from "../../const/dataEnum";

/**
 *
 * @param {boolean} show : default true
 * @param {enum} variant : alert variant [ALERT_VARIANT], default SUCCESS
 * @see {ALERT_VARIANT} enum
 * @param {string} message : default ""
 * @param {number} timeout : default 3000
 *
 */
export function setAlert({show = true, variant = ALERT_VARIANT.SUCCESS, message = "", timeout = 3000}) {
  // ConsoleLog("setAlert", , show, variant, message, timeout);
  return {type: AlertModalActionType.SET_ALERT, show, variant, message, timeout};
}
